module.exports = __webpack_public_path__ + "static/media/arrowLeftImage.5025390d.svg";